import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ServicesSectionRow {
  id: string;
  name: string;
  category: string | null;
  price: string;
  description: string | null;
}

/**
 * Active services for the ServicesSection component, optionally filtered to a
 * specific set of categories. The `categories` array is included in the query
 * key so the result refreshes whenever the prop changes.
 */
export function useServicesSectionData(
  orgId: string | undefined,
  categories: string[] | undefined,
) {
  return useQuery({
    queryKey: ['services-section', orgId, categories],
    enabled: Boolean(orgId),
    queryFn: async (): Promise<ServicesSectionRow[]> => {
      let query = supabase
        .from('services')
        .select('id, name, category, price, description')
        .eq('organization_id', orgId!)
        .eq('is_active', true)
        .order('sort_order');

      if (categories && categories.length > 0) {
        query = query.in('category', categories);
      }

      const { data, error } = await query;
      if (error) throw error;

      return (data ?? []) as ServicesSectionRow[];
    },
  });
}
